// src/components/search/utils/dateFormatters.ts

export const formatDate = (dateString: string): string => {
  if (!dateString) return 'Fecha no disponible';

  const date = new Date(dateString);
  if (isNaN(date.getTime())) {
    return 'Fecha no disponible';
  }

  return new Intl.DateTimeFormat('es-ES', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(date);
};

export const formatTime = (dateString: string): string => {
  if (!dateString) return 'Hora no disponible';

  const date = new Date(dateString);
  if (isNaN(date.getTime())) {
    return 'Hora no disponible';
  }

  const hours = date.getHours();
  const minutes = date.getMinutes();

  if (hours === 0 && minutes === 0) {
    return 'Todo el día';
  }

  return new Intl.DateTimeFormat('es-ES', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  }).format(date);
};
